// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1KS6U","balanceDisclaimer":"posDashboard_balanceDisclaimer__1aEgU"};